import { render, staticRenderFns } from "./cashierform.vue?vue&type=template&id=135ecf44&scoped=true&"
import script from "./cashierform.vue?vue&type=script&lang=js&"
export * from "./cashierform.vue?vue&type=script&lang=js&"
import style0 from "./cashierform.vue?vue&type=style&index=0&id=135ecf44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ecf44",
  null
  
)

export default component.exports